module.exports = __webpack_public_path__ + "static/media/Home-YellowBlockMobile.57cfa41d.svg";